import { render, staticRenderFns } from "./NationalTrademarkNoteTypeList.vue?vue&type=template&id=38a473e1&"
import script from "./NationalTrademarkNoteTypeList.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkNoteTypeList.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkNoteTypeList.vue?vue&type=style&index=0&id=38a473e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports